export default __webpack_public_path__ + "static/media/Madras-Diocese.dcf3a732.png";